export const STATE = {
    CHECKED      : 2,
    INTERMEDIATE : 1,
    UNCHECKED    : 0
};
